import { useMemo, useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { useTasks } from '@/hooks/useTasks';
import { Button } from '@/components/ui/button';

const statusLabel: Record<string, string> = {
  pending: 'Pendente',
  in_progress: 'Em andamento',
  completed: 'Concluida',
  blocked: 'Bloqueada',
};

const priorityLabel: Record<string, string> = {
  low: 'Baixa',
  medium: 'Media',
  high: 'Alta',
  urgent: 'Urgente',
};

export default function MobileTasks() {
  const { tasks, isLoading, error, updateTask } = useTasks();
  const [updatingId, setUpdatingId] = useState<string | null>(null);

  const sorted = useMemo(() => {
    return [...(tasks || [])].sort((a, b) => {
      const aDone = a.status === 'completed' ? 1 : 0;
      const bDone = b.status === 'completed' ? 1 : 0;
      return aDone - bDone;
    });
  }, [tasks]);

  const handleToggleStatus = async (taskId: string, currentStatus: string) => {
    const nextStatus = currentStatus === 'completed' ? 'pending' : 'completed';
    const payload: Record<string, string | null> = {
      id: taskId,
      status: nextStatus,
      completed_at: nextStatus === 'completed' ? new Date().toISOString() : null,
    };

    setUpdatingId(taskId);
    try {
      await updateTask.mutateAsync(payload);
    } finally {
      setUpdatingId(null);
    }
  };

  return (
    <div className="space-y-2 p-3">
      {isLoading ? <p className="text-sm text-muted-foreground">Carregando tarefas...</p> : null}
      {error ? <p className="text-sm text-destructive">Erro ao carregar tarefas.</p> : null}

      {sorted.map((task) => (
        <div key={task.id} className="rounded-lg border bg-card p-3">
          <p className="text-sm font-semibold">{task.title}</p>
          <div className="mt-2 flex items-center gap-2 text-xs">
            <Badge variant="outline">{statusLabel[task.status] || task.status}</Badge>
            <Badge variant="secondary">{priorityLabel[task.priority] || task.priority}</Badge>
          </div>
          <div className="mt-3">
            <Button
              size="sm"
              variant={task.status === 'completed' ? 'outline' : 'default'}
              disabled={updatingId === task.id}
              onClick={() => handleToggleStatus(task.id, task.status)}
            >
              {updatingId === task.id ? 'Atualizando...' : task.status === 'completed' ? 'Reabrir' : 'Concluir'}
            </Button>
          </div>
        </div>
      ))}

      {!isLoading && sorted.length === 0 ? (
        <p className="text-sm text-muted-foreground">Nenhuma tarefa encontrada.</p>
      ) : null}
    </div>
  );
}
